function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.61 28.06c3.21 3.74 8.02 6.12 13.41 6.15 4.85 0.02 9.25-1.87 12.42-4.96q-1.14 0.2-2.16 0.2c-6.64-0.03-13.62-3.82-17.91-9.34 0 0-5.75 7.95-5.76 7.95zm7.35-10.17c3.77 4.51 9.7 7.93 15.48 7.96q2.32 0 3.97-0.78l-8.95-21.7zm-11.46-0.78c0 3.55 1.12 6.84 3.02 9.58l5.8-8.01c-1.96-2.98-3.15-6.38-3.15-9.91 0-3.19 1.88-5.68 2.88-6.21-5.12 2.94-8.55 8.35-8.55 14.55zm33.17 6.23c1.21-1.47 1.83-3.54 1.83-6.1-0.02-7.66-5.27-14.16-12.46-16.29zm-25.69-14.93c0 2.7 1.09 5.52 2.91 8.09l11.41-15.76q-2.07-0.53-4.29-0.54c-7.7-0.04-10.03 4.36-10.03 8.21z"
})));
var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t");
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m152.6 32.1l-0.7-0.5c-0.3-0.3-0.6-0.5-1-0.8q-0.6-0.6-1.5-1.3c-0.7 0.7-2.5 2.1-5.4 2.1-4 0-5.5-3.2-5.5-5 0-2.1 1-4 3.1-5.2-0.7-0.9-0.9-1.8-0.9-2.7 0-2.1 2-4.2 4.9-4.2q0.8 0 1.5 0.1h0.3v2.2l-0.7-0.6c-0.3-0.2-0.7-0.2-1.5-0.2-1 0-2.3 0.5-2.3 2.3 0 1.4 1.1 2.7 3.3 5 0.6 0.7 2.7 2.7 3.7 3.4 0.6-0.6 1.4-1.8 1.7-3v-0.3l1.4-0.1-0.1 0.4c-0.2 1.4-1 2.9-1.8 4q0.7 0.6 1.3 1l0.2 0.1zm-10.3-9.4q-1.4 1.1-1.4 2.9c-0.1 2.3 1.6 4.1 3.8 4.1 1.7 0 2.8-0.7 3.4-1.1-1.2-1.1-3-2.7-3.5-3.3-0.2-0.2-1.5-1.6-2.3-2.6z"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path: Clip-Path",
  clipPath: "url(#cp1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m26.1-16l-53.3 18.5 23.1 43.3 53.4-18.5z"
}))));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m51.5 25.7l-2 5h-3.3l7.7-19.8h3.4l7.7 19.9h-3.4l-1.9-5zm7.1-2.7l-3-8.3-3.1 8.3z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m68.4 11h3.1v19.9h-3.1z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m94.2 27.6c-1.9 2.2-4.6 3.6-8 3.6-5.8-0.1-10.3-4.6-10.2-10.2 0-5.6 4.5-10.2 10.2-10.1 3.3 0 6.1 1.3 7.9 3.5l-2.4 1.8c-1.4-1.4-3.3-2.4-5.5-2.4-4 0-7.1 3.1-7.1 7.2 0 4 3.1 7.2 7.1 7.2 2.3 0 4.3-0.9 5.5-2.5z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m98.3 11.1l8.2 0.1c4.4 0 6.1 3.2 6.1 6.4 0.1 3.1-1.7 6.2-6.2 6.2l-5-0.1v7.3h-3.2zm3.2 2.9v6.9h4.8c2.3 0 3.3-1.7 3.3-3.4 0-1.7-1-3.5-3.1-3.5z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m126.4 26.2l-8.2-0.1-2.1 5h-3.3l7.8-19.8h3.4l7.6 19.9h-3.3zm-1-2.7l-3.1-8.5-3 8.4z"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m176.6 28.1c-1.8 2.3-4.6 3.6-7.9 3.6-5.7-0.1-10.2-4.6-10.3-10.3 0-5.5 4.6-10.1 10.3-10.1 3.3 0 6.1 1.5 7.9 3.7l-2.5 1.8c-1.3-1.5-3.1-2.5-5.4-2.5-4 0-7.1 3.2-7.1 7.2 0 4 3 7.3 7.1 7.3 2.2 0 4.2-1.1 5.5-2.6z"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m180.6 11.6h3.1v19.9h-3.1z"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m208.2 11.8h2.8l2.4 19.9h-3.1l-1.7-14.2-6 12-2.7-0.1-5.9-12-1.8 14.2h-3.1l2.4-19.9h2.8l6.9 14.2z"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m221 26.8l-2 4.9h-3.4l7.8-19.8h3.3l7.8 19.9h-3.4l-1.9-4.9zm1.1-2.9l6 0.1-3-8.4z"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m38.2 29.1q0-0.4 0.3-0.8 0.3-0.4 0.8-0.7 0.6-0.2 1.2-0.2 0.6 0 1.2 0.2 0.5 0.3 0.8 0.7 0.3 0.4 0.3 0.8 0 0.5-0.3 0.9-0.3 0.4-0.8 0.7-0.6 0.2-1.2 0.2-0.6 0-1.2-0.3-0.5-0.2-0.8-0.6-0.3-0.4-0.3-0.9zm0.4 0q0 0.4 0.2 0.8 0.3 0.3 0.7 0.5 0.5 0.2 1 0.2 0.6 0 1-0.2 0.4-0.2 0.7-0.5 0.2-0.4 0.2-0.8 0-0.3-0.2-0.7-0.3-0.3-0.7-0.5-0.5-0.2-1-0.2-0.5 0-1 0.2-0.4 0.2-0.7 0.5-0.2 0.4-0.2 0.7zm1.4 0.2v0.8h-0.5v-2h1q0.5 0 0.7 0.2 0.3 0.2 0.3 0.5 0 0.2-0.3 0.3 0.2 0.1 0.2 0.2 0.1 0.2 0.1 0.4 0 0.2 0 0.2 0 0.1 0.1 0.2h-0.5q-0.1-0.1-0.1-0.4 0-0.2-0.1-0.3-0.1-0.1-0.3-0.1zm0.5-0.3q0.2 0 0.4-0.1 0.1 0 0.1-0.2 0-0.1-0.1-0.2-0.1-0.1-0.4-0.1h-0.5v0.6z"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m128.6 13.8q0-0.5 0.2-0.8 0.3-0.5 0.7-0.7 0.4-0.2 0.8-0.2 0.4 0 0.8 0.2 0.4 0.2 0.7 0.7 0.2 0.3 0.2 0.8 0 0.5-0.2 0.9-0.3 0.3-0.7 0.6-0.4 0.2-0.9 0.2-0.3 0-0.7-0.2-0.4-0.3-0.7-0.6-0.2-0.4-0.2-0.9zm0.3 0q0 0.4 0.2 0.7 0.1 0.3 0.4 0.5 0.4 0.3 0.7 0.3 0.4 0 0.8-0.3 0.3-0.2 0.5-0.5 0.2-0.3 0.2-0.7 0-0.4-0.2-0.7-0.2-0.3-0.5-0.6-0.3-0.2-0.7-0.2-0.4 0-0.8 0.2-0.3 0.2-0.4 0.6-0.2 0.3-0.2 0.7zm1 0.9h-0.3v-2h0.7q0.4 0 0.5 0.3 0.3 0.1 0.2 0.4 0 0.2-0.3 0.4 0.2 0 0.3 0.2 0 0.2 0 0.3 0 0.2 0 0.3 0 0.1 0 0.1h-0.3q-0.1 0-0.1-0.4 0-0.1 0-0.2-0.1-0.1-0.3-0.2h-0.4zm0-1c0.1 0 0.6 0 0.7 0q0.1-0.2 0.1-0.3 0-0.2-0.1-0.2-0.1-0.1-0.3-0.1h-0.4z"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m232.4 14.4q0-0.5 0.1-0.8 0.3-0.5 0.7-0.7 0.4-0.2 0.8-0.2 0.5 0 0.8 0.2 0.4 0.2 0.7 0.7 0.2 0.3 0.2 0.9 0 0.4-0.2 0.8-0.3 0.4-0.7 0.6-0.4 0.2-0.8 0.2-0.4 0-0.8-0.2-0.4-0.3-0.7-0.6-0.1-0.4-0.1-0.9zm0.2 0q0 0.4 0.2 0.7 0.2 0.3 0.5 0.5 0.3 0.3 0.7 0.3 0.4 0 0.7-0.3 0.4-0.2 0.5-0.5 0.2-0.3 0.2-0.6 0-0.5-0.2-0.8-0.1-0.3-0.4-0.6-0.4-0.2-0.8-0.2-0.4 0-0.7 0.2-0.3 0.2-0.5 0.6-0.2 0.3-0.2 0.7zm1 0.9h-0.4v-2h0.7q0.4 0.1 0.6 0.3 0.2 0.1 0.2 0.4 0 0.2-0.3 0.3 0.2 0.1 0.2 0.3 0.1 0.2 0.1 0.3 0 0.2 0 0.3 0 0 0 0.1h-0.3q0 0 0-0.4 0-0.1-0.1-0.2-0.1-0.1-0.3-0.1l-0.4-0.1zm0-1c0.2 0 0.5 0 0.6 0q0.2-0.1 0.2-0.3 0-0.2-0.1-0.2-0.1-0.1-0.3-0.1h-0.4zm0 0.3h0.1z"
});
const SvgAicpaCimaLogoWhite = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 288 34",
  width: 288,
  height: 34,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAicpaCimaLogoWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/aicpa-cima-logo-white.a5166e83.svg";
export { ForwardRef as ReactComponent };